import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import _ from 'lodash'

import Form from 'main_views/components/Form/form_v2'
import { setFieldValue, getFieldsValues } from 'main_views/form/formHandler'

let Generator = forwardRef((props, ref) => {

   let { form } = props

   let [formData, setFormData] = useState(form)

   useEffect(() => {
      if (_.isEmpty(form)) return

      let data = {}
      _.forEach(form.data, i => {

         data[i.stateName] = {
            ...i,
            stateName: i.stateName,
            type: i.type,
            required: i.required ?? false,
            label: i.label ?? null,
            options: i.options ?? []
         }
      })

      setFormData(data)
   }, [form])

   useImperativeHandle(ref, () => ({

      // calls from parents
      getData() {

         let { data, isValid } = getFieldsValues(formData)

         return {
            formData,
            isValid, // all required field ws filled
         }

      }

   }))

   let setChanges = (stateName, value, className) => {
      setFieldValue(formData, stateName, value, className)
      setFormData({ ...formData }) // to re-render the form 
   }

   if (_.isEmpty(form)) return <></>

   return (
      <div className='p-3'>

         <Form
            inputs={formData}
            onChange={setChanges}
         />

         {!_.find(form.allowFileAttachments, opt => opt.id === "noFile")?.checked && (
            <div className='mt-5'>
               <input 
                  type='file' 
                  id='files'
                  multiple={_.find(form.allowFileAttachments, opt => opt.id === "multi")?.checked}
               />
            </div>
         )}
         
      </div>
   )
})

export default Generator
